import { Serializable } from "./serializable";
import Address from "./address";
import { UtilitiesFunctions } from "@/helpers";

export default class Cellar implements Serializable<Cellar> {
  id?: string;
  address?: Address;
  avatar?: string;
  cardLink: string = "cellar";
  cardType: string = "cellarCard";
  cellarServicesTags?: any[];
  cellarLanguagesTags?: any[];
  cellarMissionTags?: any[];
  cover?: string;
  description?: string;
  headerImage?: string;
  images?: any[];
  nearbyCities?: any[];
  openingHours?: string;
  spokenLanguages?: any[];
  title?: string;
  metaTitle?: string;
  metaDescription?: string;

  deserialize(input: any): Cellar {
    if (input != null) {
      this.id = input.id;
      // this.avatar = "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg";
      if (input.avatar_image && input.avatar_image.urls)
        this.avatar = input.avatar_image.urls ? input.avatar_image.urls.s : ""; // Avatar image
      if (input.place)
        this.address = new Address().deserialize(input.place) || null;
      if (input.description)
        this.description = input.description.replace(/\n/g, "<br>") || null;
      if (input.photos && input.photos.length > 0) {
        this.images =
          input.photos.map((item: any) => {
            if (item.cover) this.cover = item.urls.m || null;
            if (item.urls) return item.urls.l; // Cellar gallery
          }) || [];
        if (input.photos[0].urls) {
          if (!this.cover) this.cover = input.photos[0].urls.m; // Cellar main
        }
      }
      if (input.header_image) {
        if (input.header_image.urls)
          this.headerImage = input.header_image.urls.xl; // Cellar header image
      }
      if (input.nearby_cities)
        this.nearbyCities = input.nearby_cities.split("\n") || [];
      if (input.opening_hours)
        this.openingHours = input.opening_hours.replace(/\n/g, "<br>") || "";
      this.spokenLanguages = input.spokenLanguages || [];
      this.title = input.name || "";
      if (input.tags) {
        this.cellarServicesTags =
          UtilitiesFunctions.buildIconTagsArray(input.tags, "services") || [];
        this.cellarLanguagesTags =
          UtilitiesFunctions.buildTagsArray(input.tags, "spklang") || [];
        this.cellarMissionTags =
          UtilitiesFunctions.buildIconTagsArray(input.tags, "mission") || [];
      }
      this.metaTitle = input.meta_title;
      this.metaDescription = input.meta_description;
    }
    return this;
  }
}
